import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  currentUser: null,
  showPromotionModal: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setShowPromotionModal(state, action) {
      state.showPromotionModal = action.payload;
    },
  },
});

export const { setCurrentUser, setShowPromotionModal } = userSlice.actions;

export const userReducer = userSlice.reducer;
